import styled, { css } from 'styled-components';
import { TabButtonProps } from './TabButton.typed';

export const TabButton = styled.button<TabButtonProps & { active?: boolean }>`
  border-radius: 4px;
  font-size: 16px;
  line-height: 24px;
  padding: 8px;
  background-color: #ffffff;
  border: ${({ theme }) => `1px solid ${theme.brand.secondary.base}`};
  color: ${({ theme }) => theme.brand.secondary.dark};
  font-weight: ${({ theme }) => theme.typography.fontWeights.regular};
  width: ${({ inline }) => (inline ? 'auto' : '100%')};
  height: ${({ height, theme }) =>
    height
      ? theme.components.button.sizes[height]
      : theme.components.button.sizes.m};

  cursor: pointer;
  display: ${({ inline }) => (inline ? 'inline-flex' : 'flex')};
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  ${({ active }) =>
    active &&
    css`
      border: ${({ theme }) => `2px solid ${theme.brand.secondary.dark}`};
      color: ${({ theme }) => theme.brand.secondary.darker};
      font-weight: ${({ theme }) => theme.typography.fontWeights.bold};
    `}
`;
